export function exportCSV(data: any[], filename = "members.csv") {
  if (!data.length) return;

  const headers = Object.keys(data[0]);

  const csv = [
    headers.join(","),
    ...data.map((row) =>
      headers.map((field) => JSON.stringify(row[field] ?? "")).join(",")
    ),
  ].join("\n");

  const blob = new Blob([csv], { type: "text/csv" });

  const url = window.URL.createObjectURL(blob);

  const a = document.createElement("a");
  a.href = url;
  a.download = filename;

  a.click();
}
